import { View, StyleSheet } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export interface OnboardingProgressProps {
  totalSteps: number;
  currentStep: number;
  color?: string;
}

export function OnboardingProgress({ totalSteps, currentStep, color = '#ffffff' }: OnboardingProgressProps) {
  return (
    <View style={styles.container}>
      {Array.from({ length: totalSteps }, (_, index) => {
        const isActive = index === currentStep;

        return (
          <View
            key={index}
            style={[
              styles.segment,
              isActive
                ? {
                    ...styles.activeSegment,
                    backgroundColor: color,
                  }
                : styles.inactiveSegment,
            ]}
          />
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    gap: 12, // modern spacing
    width: '60%', // responsive width
    justifyContent: 'center',
    alignSelf: 'center',
  },
  segment: {
    height: 4, // slim height
    width: 9,
    borderRadius: 4, // smooth modern look
  },
  activeSegment: {
    // backgroundColor: '#1F2635', // primary color
    width: 26, // wider active segment
  },
  inactiveSegment: {
    backgroundColor: theme.colors['text.placeholder'],
  },
});
